import { NextSeo } from 'next-seo';
import Script from 'next/script';

const TITLE = 'Crehana Jobs - Let’s make career development universal';
const DESCRIPTION =
  'We believe in a world where people can design their professional futures in collaboration with others. A world where skills can be accessed anytime, anywhere. A world where you can learn forever.';

const App = () => {
  return (
    <>
      <NextSeo
        title={TITLE}
        description={DESCRIPTION}
        openGraph={{
          title: TITLE,
          description: DESCRIPTION,
          images: [
            {
              url: 'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-d41f7cb8-998f-4f78-be7f-6fcb3af6bd55-seo.jpg?auto=format',
              alt: 'Crehana Jobs',
            },
          ],
        }}
      />
      <div id="grnhse_app" />
      <Script
        key="greenhouse-script"
        strategy="afterInteractive"
        src="https://boards.greenhouse.io/embed/job_board/js?for=crehana"
      />
    </>
  );
};

export default App;
